export const CustomStringify = (obj) => {
  return JSON.stringify(obj, (key, value) => {
    // Replace undefined values with null
    if (value === undefined) {
      if (key.toLowerCase()?.includes("date")) {
        return null;
      } else {
        return "";
      }
    }
    return value;
  });
};
